import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { COLORS } from "../../constants";
import { useMediaQuery } from "react-responsive";
import useSystemHook from "./../../hooks/SystemHook";
import { ApiCallStatus } from "../../utils/constants";

const RsvpModal = ({
  open,
  onClose,
  createEventResponseCallStatus,
  setSelectedYear,
}) => {
  const { isMobile, isTablet, isDesktop } = useSystemHook();
  const isDuplicateError =
    createEventResponseCallStatus === ApiCallStatus.Conflict;

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "90%" : 600,
    backgroundColor: isDuplicateError ? COLORS.white : COLORS.themeYellow,
    boxShadow: 24,
    borderRadius: "2px",
    display: "flex",
    flexDirection: "column",
    maxHeight: "90vh",
    overflowY: "auto",
  };

  const headerStyle = {
    backgroundColor: isDuplicateError ? COLORS.themeBlack : COLORS.themeYellow,
    borderBottom: isDuplicateError ? `1px solid ${COLORS.border}` : "none",
    px: 4,
    py: 3,
  };

  const contentStyle = {
    backgroundColor: COLORS.white,
    py: 5,
    px: 2,
    textAlign: "center",
  };

  const handleCheckPreviousTradeshows = () => {
    setSelectedYear("2024");
    onClose();
  };

  // Only shown for the duplicate-email case now — the success case is image + button only.
  const modalTitle = "Email Already Used";
  const modalDescription =
    "This email has already been used to RSVP for the Trade Show. Please use a different email address to submit another RSVP.";

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="rsvp-modal-title"
      aria-describedby="rsvp-modal-description"
    >
      <Box sx={modalStyle}>
        <Box sx={headerStyle}>
          <Button
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              minWidth: "auto",
              p: 1,
              color: COLORS.darkText,
            }}
          >
            <CloseIcon
              sx={{
                color: isDuplicateError ? COLORS.white : COLORS.themeBlack,
              }}
            />
          </Button>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src={
                isDuplicateError
                  ? "https://argusweb.azureedge.net/argus-web/trade-show/emailError.svg"
                  : "https://argusweb.azureedge.net/argus-web/trade-show/Tradeshow-POPUP.png"
              }
              alt={isDuplicateError ? "Email Error" : "Trade Show Sign"}
              style={{
                width: "100%",
                height: "auto",
                maxWidth: 640,
              }}
            />
          </Box>
        </Box>
        {isDuplicateError && (
          <Box sx={contentStyle}>
            <Typography
              id="rsvp-modal-title"
              variant="h5"
              sx={{
                mb: 2,
                fontWeight: 500,
                color: COLORS.darkText,
                fontSize: isMobile
                  ? "var(--font-size-l)"
                  : "var(--font-size-xl)",
              }}
            >
              {modalTitle}
            </Typography>
            <Typography
              id="rsvp-modal-description"
              variant="body2"
              sx={{
                color: COLORS.lightText,
                fontSize: isMobile
                  ? "var(--font-size-xxs)"
                  : "var(--font-size-xs)",
              }}
            >
              {modalDescription}
            </Typography>
          </Box>
        )}
        {!isDuplicateError && (
          <Button
            onClick={handleCheckPreviousTradeshows}
            sx={{
              py: 2,
              m: 3,
              mt: 3,
              backgroundColor: COLORS.themeRed,
              color: COLORS.white,
              borderRadius: 20,
              fontWeight: 500,
              textTransform: "uppercase",
              fontSize: isMobile
                ? "var(--font-size-xxs)"
                : "var(--font-size-xs)",
              "&:hover": {
                backgroundColor: COLORS.themeBlack,
                color: COLORS.white,
              },
            }}
          >
            Check Out Previous Tradeshows!
          </Button>
        )}
      </Box>
    </Modal>
  );
};

export default RsvpModal;
